<template>
  <div class="detail">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">
        <span> {{ info.className }} 评价详情</span>
      </div>
      <div class="right"></div>
    </div>
    <div>
      <el-form ref="form" :inline="true" :model="form" label-width="90px">
        <el-form-item label="学年学期">
           <el-select
              v-model="form.value1"
              clearable
              placeholder="请选择"
              class="label"
            >
              <el-option
                v-for="item in list1"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="上课日期">
              <el-date-picker 
				   	v-model="form.time"
				   	type="daterange"
				   	style="width: 240px;"
				   	range-separator="-"
				   	start-placeholder="开始日期"
				   	end-placeholder="结束日期"
				   	:picker-options="pickerOptions">
			 </el-date-picker>
        </el-form-item>
        <el-form-item label="星级">
           <el-select v-model="form.star" clearable placeholder="选择星级" class="label">
                        <el-option v-for="item in starList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" @click="searchFun"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="studentName" label="评价人" align="center">
          </el-table-column>
          <el-table-column prop="className" label="评价时间" align="center">
          </el-table-column>
          <el-table-column prop="signTime" label="身份" align="center">
          </el-table-column>
		    <el-table-column prop="a" label="班级" align="center">
          </el-table-column>
          <!-- <el-table-column prop="className" label="账号" align="center">
          </el-table-column> -->
          <el-table-column prop="b" label="评价星级" align="center">
          </el-table-column>
		   <el-table-column prop="c" label="评价内容" align="center">
          </el-table-column>
        </el-table>
        <div class="pagination">
          <!--分页组件-->
          <el-pagination
            background
            :current-page="page.pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="page.pageSize"
            :total="page.totalPage"
            layout="total,prev, pager, next,jumper,sizes"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index";
export default {
  props: {
    info: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      form: {
		  value1:"",
        time: "",
        star: "",
        studentName: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage:10,
      },
      tableData: [
    //     {studentName:'莫莎静',className:'2021/12/1 20:46:44', signTime:'学生',a:'三年级2班',b:'5星',c:'很好很好很好很好很好很好',},
		// {studentName:'裴君静',className:'2021/11/11 10:06:56',signTime:'家长',a:'四年级3班',b:'3星',c:'我觉得比较一般',},
		// {studentName:'陆秋叶',className:'2021/11/5 7:13:18',  signTime:'学生',a:'五年级7班',b:'5星',c:'这个课程的新颖模式，科学的思维方法，对孩子是一个很好的启蒙！',},
		// {studentName:'宁颖姬',className:'2021/11/28 0:13:30', signTime:'家长',a:'二年级4班',b:'5星',c:'这个课程的新颖模式，科学的思维方法，对孩子是一个很好的启蒙！',},
		// {studentName:'仇云瑗',className:'2021/11/11 22:27:24',signTime:'学生',a:'一年级3班',b:'5星',c:'还行吧',},
		// {studentName:'傅秋菲',className:'2021/11/23 17:18:01',signTime:'学生',a:'四年级4班',b:'3星',c:'我觉得比较一般',},
		// {studentName:'叶马蕊',className:'2021/11/18 8:47:28', signTime:'家长',a:'五年级7班',b:'4星',c:'这个课程的新颖模式，科学的思维方法，对孩子是一个很好的启蒙！',},
		// {studentName:'贾荔露',className:'2021/12/1 2:22:33',  signTime:'家长',a:'三年级2班',b:'5星',c:'这个课程的新颖模式，科学的思维方法，对孩子是一个很好的启蒙！',},
		// {studentName:'路馥爽',className:'2021/11/19 22:26:38',signTime:'学生',a:'四年级3班',b:'2星',c:'不满意老师',},
		// {studentName:'娄芝娟',className:'2021/11/25 1:04:08', signTime:'学生',a:'五年级7班',b:'1星',c:'学不会',},
        
      ],
	  starList: [
				{id:'star1',label:'1星'},
				{id:'star2',label:'2星'},
				{id:'star3',label:'3星'},
				{id:'star4',label:'4星'},
				{id:'star5',label:'5星'},
				{id:'star6',label:'6星'},
				{id:'star7',label:'7星'},
			],
	   list1:[
				{id:"1",label:"2021~2022年度下学期	  ",  value:"1"},
				{id:"2",label:"2021~2022年度上学期	 ",value:"2"},
				{id:"3",label:"2020~2021年度下学期	 ",  value:"3"},
				{id:"4",label:"2020~2021年度上学期	 ",value:"4"},
				{id:"5",label:"2019~2020年度下学期	 ",  value:"5"},
				{id:"6",label:"2019~2020年度上学期	  ",value:"6"},
			],
      campusList: [
        {id:'campus1',label:'驻马店实验小学主校区'},
      ],
      gradeList: [
        {id:'g1',label:'一年级'},
				{id:'g2',label:'二年级'},
				{id:'g3',label:'三年级'},
				{id:'g4',label:'四年级'},
				{id:'g5',label:'五年级'},
				{id:'g6',label:'六年级'},
      ],
	        	pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
      school_info: JSON.parse(sessionStorage.getItem("classList"))||[],
    };
  },
 watch: {
    info: {
      handler: function () {
        // this.getDataList();
      },
      deep: true,
    },
    // "form.campusId": function (n, o) {
    //   this.form.gradeId = "";
    //   this.gradeList = [];
    //   this.gradeList =
    //     this.campusList.filter((v) => v.id === n)[0]?.children || [];
    // },
  },
  created() {
    // this.getDataList();
    // if(this.school_info.length>0){
    //     this.campusList = this.school_info.slice();
    // }
  },
  methods: {
    async getDataList() {
      let params = {
        schoolYearSemester: "",
        gradeId: this.form.gradeId,
        campusId: this.form.campusId,
        courseName: "",
        courseApplyId: this.info.courseApplyId,
        studentName: this.form.studentName,
        orgId:sessionStorage.getItem('orgId'),
        platformCode: sessionStorage.getItem('platformCode'),
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };
      var { data, code } = await api.handleStudentDetails(params);
      console.log("获取列表数据---", data, code);
      if (code == "0") {
        this.tableData = data.list;
        this.page.totalPage = data.total;
        //  this.page.pageSize=data.pageSize
        //  this.page.pageNum=data.pageNum
      }
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },

    toIndex() {
      this.$emit("to-index");
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
